import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { ReactiveFormsModule } from '@angular/forms';
import { MatAutocompleteModule } from '@angular/material/autocomplete';
import { MatButtonModule } from '@angular/material/button';
import { MatIconModule } from '@angular/material/icon';
import { MatInputModule } from '@angular/material/input';
import { MatProgressSpinnerModule } from '@angular/material/progress-spinner';

import { UserPickerComponent } from './user-picker.component';
import { UserCreationDialogComponent } from './user-creation-dialog.component';

@NgModule({
    imports: [
        CommonModule,
        MatAutocompleteModule,
        MatButtonModule,
        MatIconModule,
        MatInputModule,
        MatProgressSpinnerModule,
        ReactiveFormsModule
    ],
    declarations: [
        UserCreationDialogComponent,
        UserPickerComponent
    ],
    exports: [
        UserCreationDialogComponent,
        UserPickerComponent
    ]
})
export class UserPickerModule {
}
